import { ErrorMessage, MessageAlignment } from '../../common/error-message/ErrorMessage';

/**
 * The component that is displayed during the authentication flow.
 */
export const ErrorMessageAuthorization = (): JSX.Element | null => {
  return <ErrorMessage keyMessage="AuthorizationError" alignMessage={MessageAlignment.Top}></ErrorMessage>;
};
